import { SettingsButton } from 'components/CantileverButton'
import { PageHeaderWithIcon } from 'components/PageHeaderWithIcon'
import { INBOX_HEADER_COLOR } from 'features/inbox/colors'
import { Inbox } from 'lucide-react'
import { FC, memo } from 'react'
import styled from 'styled-components'

const APP_TITLE = 'Inspections'

const LOW_OPACITY_DARK_BLUE = 'rgba(10,111,219, 0.15)'
const LOW_OPACITY_LIGHT_BLUE = 'rgba(159,225,255, 0.6)'

const OuterHeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-right: 0.625rem;
  background-color: ${INBOX_HEADER_COLOR};
`

const InnerHeaderContainer = styled.div`
  width: 100%;
`

interface InboxPageHeaderProps {
  readonly handleSettingsClick?: () => void
  readonly subtitle?: string
}

const InboxPageHeaderComponent: FC<InboxPageHeaderProps> = ({
  handleSettingsClick,
  subtitle,
}) => {
  return (
    <OuterHeaderContainer>
      <InnerHeaderContainer>
        <PageHeaderWithIcon
          title={APP_TITLE}
          subtitle={subtitle}
          icon={
            <Inbox size={27} strokeWidth={2} color={LOW_OPACITY_LIGHT_BLUE} />
          }
          iconBackgroundColor={LOW_OPACITY_DARK_BLUE}
          trailingContent={
            handleSettingsClick ? (
              <SettingsButton title='Settings' onClick={handleSettingsClick} />
            ) : undefined
          }
        />
      </InnerHeaderContainer>
    </OuterHeaderContainer>
  )
}

export const InboxPageHeader = memo(InboxPageHeaderComponent)

export default InboxPageHeader
